import apiClient from './apiClient';

export class ListingsService {

    async getListing(id) {
        const response = await apiClient.getWithCache("api/listings/" + id);
        return response.data;
    }

    async getListingsForSnapshot(snapshotId, search) {
        const response = await apiClient.getWithCache("api/listings/snapshot/" + snapshotId, {
            params: search
        });

        return response.data;
    }

    async deleteListing(id) {
        const response = await apiClient.delete("api/listings/delete/" + id);
        apiClient.clearCache('api/listings');
        return response.data;
    }

    async getExcludedListingsForSnapshot(snapshotId) {
        const response = await apiClient.get(`api/listings/snapshot/${snapshotId}/excluded`);
        return response.data;
    }

    /**
     * @param {{ searchText?: string, sortOrderField?: string, sortDirection?: string, itemsPerPage?: number, itemsToSkip?: number }} search
     * @returns {Promise<{ items: Array<{ id: number, marketplaceID: number, marketplaceItemID: string, title: string, url: string,
     *   sellerUserID: string, reason: string, excludedBy: string, excludedDateTime: string }>, totalItemCount: number }>}
     */
    async getExcludedListings(search) {
        const response = await apiClient.get("api/listings/excluded", { params: search });
        return response.data;
    }

    async excludeListing(id, reason) {
        const response = await apiClient.put(`api/listings/exclude/${id}`, { reason });
        this._clearCaches();
        return response.data;
    }

    async includeListing(id) {
        const response = await apiClient.put(`api/listings/include/${id}`, {});
        this._clearCaches();
        return response.data;
    }

    async deleteExclusion(excludedListingId) {
        const response = await apiClient.delete(`api/listings/excluded/${excludedListingId}`);
        this._clearCaches();
        return response.data;
    }

    _clearCaches() {
        apiClient.clearCache('api/listings');
        apiClient.clearCache('api/snapshots');
    }
}
